import { observable, action } from 'mobx';

import httpFacade from 'http/httpFacade';
import Log from 'helpers/log';
import { RevenueReport } from 'stores/Report/types';
import { getDate } from 'helpers/datetime';
import { IntervalFetch } from 'http/intervalFetch';

class LiveStore {
  @observable report: RevenueReport;
  @observable isInit = false;

  @observable private _intervalFetch = new IntervalFetch(10000);

  constructor() {
    this._intervalFetch.setRequest(this.fetchLiveReport);
  }

  @action
  public init = async () => {
    try {
      this._intervalFetch.start();
    } catch (error) {
      Log.warn(error);
    }
  };

  @action
  public fetchLiveReport = async () => {
    try {
      const date = getDate(new Date());
      const { data } = await httpFacade.order.fetchRevenueReport({
        from: date,
        to: date,
      });

      this.report = data;
    } catch (error) {
      Log.warn(error);
    } finally {
      this.isInit = true;
    }
  };

  @action
  clearInterval = () => {
    this._intervalFetch.stop();
  };
}

export default LiveStore;
